module.exports = __webpack_public_path__ + "static/media/dolphin1.13f620da.mp3";